<template>
    <!-- Cambia el color del SVG usando clases o estilos directamente -->
    <svg
      :width="width"
      :height="height"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      aria-hidden="true"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        :fill="currentColor || '#00031c'"
        stroke="none"
      >
        <path
          d="M2524 4290 c-18 -4 -47 -16 -65 -28 -19 -11 -63 -36 -99 -55 -91 -47
    -264 -148 -270 -157 -5 -7 -39 -27 -295 -170 -71 -40 -146 -83 -165 -96 -19
    -12 -82 -47 -138 -77 -57 -30 -113 -62 -124 -72 -12 -10 -71 -47 -132 -82
    -173 -101 -182 -108 -195 -158 -8 -30 -11 -293 -11 -840 0 -875 -3 -836 62
    -894 18 -16 86 -60 150 -96 64 -37 118 -70 120 -75 2 -4 38 -26 81 -49 43 -23
    158 -88 255 -145 97 -56 201 -114 230 -129 78 -39 146 -79 157 -92 15 -17 284
    -170 397 -227 61 -30 124 -24 194 18 32 20 75 43 94 53 59 29 254 144 268 157
    7 8 43 30 80 50 117 64 244 135 352 199 58 34 146 83 195 110 50 26 91 51 93
    56 2 4 50 33 106 64 118 65 190 119 205 155 8 17 10 145 9 390 l-3 365 -26 3
    c-25 3 -181 -80 -221 -117 -9 -9 -24 -22 -33 -29 -13 -11 -15 -44 -15 -210 -1
    -263 -5 -273 -151 -350 -42 -22 -146 -81 -230 -130 -85 -49 -174 -99 -198
    -112 -24 -12 -52 -29 -62 -38 -18 -17 -285 -171 -394 -228 -33 -17 -76 -41
    -95 -52 -50 -31 -123 -29 -186 4 -27 15 -80 43 -119 64 -149 80 -361 206 -387
    229 -12 12 -26 21 -32 21 -5 0 -93 48 -195 107 -102 59 -217 123 -256 143 -46
    24 -81 52 -102 79 l-33 43 0 659 c0 708 -1 699 51 745 13 12 60 40 104 64 44
    23 132 73 195 110 114 67 169 98 239 134 20 10 38 22 41 26 7 10 367 220 379
    220 3 0 40 20 81 45 64 39 83 45 130 45 32 0 64 -6 76 -14 11 -8 64 -38 117
    -66 53 -28 120 -64 149 -82 29 -17 95 -55 147 -85 51 -30 99 -59 105 -64 15
    -12 380 -221 476 -271 78 -41 114 -69 133 -103 8 -13 14 -120 17 -324 5 -275
    7 -305 22 -315 13 -8 23 -8 35 0 10 6 38 22 63 36 25 14 68 38 95 55 28 16 58
    32 68 36 16 6 17 31 17 337 l0 330 -33 33 c-18 19 -89 67 -157 107 -69 40
    -127 75 -130 79 -5 8 -128 81 -135 81 -2 0 -93 51 -202 113 -109 62 -237 135
    -285 160 -48 26 -93 53 -100 60 -12 13 -256 157 -265 157 -2 0 -39 20 -81 44
    -83 47 -120 57 -168 46z"
        />
        <path
          d="M2474 3664 c-27 -14 -51 -29 -54 -34 -3 -4 -32 -22 -65 -40 -33 -18
    -136 -77 -230 -130 -93 -54 -195 -111 -225 -127 -151 -80 -212 -119 -231 -149
    -22 -36 -24 -72 -5 -96 11 -14 249 -158 262 -158 10 0 269 -153 279 -165 5 -7
    57 -37 115 -68 58 -30 125 -67 150 -81 68 -39 116 -35 209 16 42 23 106 58
    144 78 37 20 77 44 89 55 12 10 47 33 78 50 30 18 89 52 130 76 70 41 124 69
    136 69 2 0 3 -181 2 -402 l-3 -402 -30 -16 c-16 -8 -88 -48 -160 -89 -71 -41
    -150 -86 -175 -100 -25 -14 -49 -30 -55 -37 -5 -7 -46 -31 -90 -54 -44 -24
    -90 -49 -101 -57 -12 -7 -43 -16 -70 -19 -41 -5 -57 -1 -99 21 -27 15 -84 45
    -125 67 -41 22 -77 43 -80 48 -7 10 -349 210 -360 210 -4 0 -18 12 -29 26 -20
    25 -21 39 -21 280 l0 254 -57 37 c-32 20 -60 39 -63 43 -3 3 -33 23 -67 44
    -65 39 -92 39 -107 0 -11 -29 -7 -769 5 -802 10 -28 75 -82 99 -82 5 0 10 -4
    10 -9 0 -9 219 -141 233 -141 3 0 99 -54 214 -121 114 -66 226 -129 250 -140
    24 -11 43 -23 43 -28 0 -15 105 -61 141 -61 38 0 114 35 151 70 12 11 30 22
    40 26 11 3 116 62 235 130 118 68 218 124 221 124 9 0 236 133 250 147 8 8 27
    20 43 28 15 9 33 24 39 34 14 27 14 1115 0 1142 -6 10 -29 28 -51 39 -22 12
    -49 30 -59 40 -11 11 -45 33 -77 50 -32 16 -65 35 -75 42 -13 10 -32 4 -103
    -32 -47 -25 -95 -53 -106 -63 -11 -10 -46 -33 -77 -51 -155 -89 -205 -117
    -297 -165 -130 -69 -145 -67 -318 25 -173 92 -193 113 -146 152 12 9 27 22 34
    29 7 7 43 28 81 49 38 20 89 48 113 62 63 37 129 36 201 -2 66 -34 73 -33 218
    53 130 77 133 90 25 154 -43 25 -101 57 -130 72 -29 14 -58 32 -66 39 -27 28
    -113 66 -148 66 -20 0 -58 -12 -85 -26z"
        />
      </g>
    </svg>
</template>
<script>
export default {
  name: "logo",
  props: ["height","width","currentColor"] ,
  setup() {
    return {}
  },
}
</script>
